const CheckBoxBlankIcon = () => {

    return (<svg width="32px" height="32px" viewBox="-2.4 -2.4 28.80 28.80" fill="darkblue"
                        xmlns="http://www.w3.org/2000/svg">
        <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
        <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
        <g id="SVGRepo_iconCarrier">
            <path d="M3 3h18v18H3V3zm16 16V5H5v14h14z" fill="#darkblue"></path>
        </g>
    </svg>
    );
};

export default CheckBoxBlankIcon;
